import { render, staticRenderFns } from "./bind_recomend.vue?vue&type=template&id=2a7b01a1&scoped=true&"
import script from "./bind_recomend.vue?vue&type=script&lang=js&"
export * from "./bind_recomend.vue?vue&type=script&lang=js&"
import style0 from "./bind_recomend.vue?vue&type=style&index=0&id=2a7b01a1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7b01a1",
  null
  
)

export default component.exports